module.exports = __webpack_public_path__ + "static/media/rednote.c4598e57.png";